import { render, staticRenderFns } from "./trainingModulePageNew7.vue?vue&type=template&id=ad3c2fc6&scoped=true&"
import script from "./trainingModulePageNew7.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew7.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew7.vue?vue&type=style&index=0&id=ad3c2fc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3c2fc6",
  null
  
)

export default component.exports